import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../service/user.service';
import {MessagingService} from '../../service/messaging.service';
import {TextModalComponent} from '../../text-modal/text-modal.component';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {

  public oldPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public oldPasswordIncorrect: boolean;


  constructor(private _userService: UserService,
              public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private msgService: MessagingService) {
  }

  ngOnInit() {
  }

  validateForm() {
    return this.newPassword && this.oldPassword && this.newPassword === this.confirmPassword;
  }

  onSubmit() {
    this.oldPasswordIncorrect = false;
    if (!(this.newPassword && this.oldPassword && this.newPassword === this.confirmPassword)) {
      alert('dupa');
      return;
    }

    const passwords = {
      password: this.oldPassword,
      new_password: this.newPassword,
      new_password_confirm: this.confirmPassword
    };

    this._userService.updatePassword(passwords)
      .subscribe((result => {
        this.activeModal.dismiss('Closed on succesful submit');
        let modalRef = this.modalService.open(TextModalComponent, { backdrop: 'static' });
        modalRef.componentInstance.title = "Update Password";
        modalRef.componentInstance.content = "Password successfully changed";
      }), error => {
        this.oldPasswordIncorrect = true;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/modal-edit/update-password/update-password.component.ts